export default "../images/stackloans-partners-with-LendingPoint_PORTAL_US.png?f578510209498841cec57d185f783f82";